import { store } from '../../../../../../../resources/frontend/js/store';
import notRequired from './general-validators/not-required-validator';
import notEmpty from './general-validators/not-empty-validator';
import email from './general-validators/email-validator';
import number from './general-validators/number-validator';
import numeric from './general-validators/numeric-validator';
import alphabetic from './general-validators/alphabetic-validator';
import url from './general-validators/url-validator';
import iban from './general-validators/iban-validator';
import date from './general-validators/date-validator';
import age from './general-validators/age-validator';
import phone from './general-validators/phone-validator';
import mobile from './general-validators/mobile-validator';
import birthYear from './general-validators/birth-year-validator';
import { phoneCode } from '../../sb-phone-codes/v1/sb-phone-codes-1.0.0';

import arValidator from './countries-validators/ar.js';
import atValidator from './countries-validators/at.js';
import auValidator from './countries-validators/au.js';
import beValidator from './countries-validators/be.js';
import brValidator from './countries-validators/br.js';
import caValidator from './countries-validators/ca.js';
import chValidator from './countries-validators/ch.js';
import clValidator from './countries-validators/cl.js';
import coValidator from './countries-validators/co.js';
import crValidator from './countries-validators/cr.js';
import czValidator from './countries-validators/cz.js';
import deValidator from './countries-validators/de.js';
import dkValidator from './countries-validators/dk.js';
import ecValidator from './countries-validators/ec.js';
import esValidator from './countries-validators/es.js';
import fiValidator from './countries-validators/fi.js';
import frValidator from './countries-validators/fr.js';
import gbValidator from './countries-validators/gb.js';
import grValidator from './countries-validators/gr.js';
import gtValidator from './countries-validators/gt.js';
import hkValidator from './countries-validators/hk.js';
import huValidator from './countries-validators/hu.js';
import idValidator from './countries-validators/id.js';
import ieValidator from './countries-validators/ie.js';
import ilValidator from './countries-validators/il.js';
import inValidator from './countries-validators/in.js';
import itValidator from './countries-validators/it.js';
import jpValidator from './countries-validators/jp.js';
import krValidator from './countries-validators/kr.js';
import ltValidator from './countries-validators/lt.js';
import luValidator from './countries-validators/lu.js';
import mxValidator from './countries-validators/mx.js';
import myValidator from './countries-validators/my.js';
import nlValidator from './countries-validators/nl.js';
import noValidator from './countries-validators/no.js';
import nzValidator from './countries-validators/nz.js';
import peValidator from './countries-validators/pe.js';
import phValidator from './countries-validators/ph.js';
import plValidator from './countries-validators/pl.js';
import ptValidator from './countries-validators/pt.js';
import roValidator from './countries-validators/ro.js';
import seValidator from './countries-validators/se.js';
import sgValidator from './countries-validators/sg.js';
import svValidator from './countries-validators/sv.js';
import thValidator from './countries-validators/th.js';
import trValidator from './countries-validators/tr.js';
import twValidator from './countries-validators/tw.js';
import usValidator from './countries-validators/us.js';
import vnValidator from './countries-validators/vn.js';
import zaValidator from './countries-validators/za.js';

export const setCountryValidator = () => {
    let countryFile = '';

    switch (store.state.page.countryCode) {
        case 'ar':
            countryFile = arValidator;
            break;

        case 'at':
            countryFile = atValidator;
            break;

        case 'au':
            countryFile = auValidator;
            break;

        case 'be':
            countryFile = beValidator;
            break;

        case 'br':
            countryFile = brValidator;
            break;

        case 'ca':
            countryFile = caValidator;
            break;

        case 'ch':
            countryFile = chValidator;
            break;

        case 'cl':
            countryFile = clValidator;
            break;

        case 'co':
            countryFile = coValidator;
            break;

        case 'cr':
            countryFile = crValidator;
            break;

        case 'cz':
            countryFile = czValidator;
            break;

        case 'de':
            countryFile = deValidator;
            break;

        case 'dk':
            countryFile = dkValidator;
            break;

        case 'ec':
            countryFile = ecValidator;
            break;

        case 'es':
            countryFile = esValidator;
            break;

        case 'fi':
            countryFile = fiValidator;
            break;

        case 'fr':
            countryFile = frValidator;
            break;

        case 'gb':
            countryFile = gbValidator;
            break;

        case 'gr':
            countryFile = grValidator;
            break;

        case 'gt':
            countryFile = gtValidator;
            break;

        case 'hk':
            countryFile = hkValidator;
            break;

        case 'hu':
            countryFile = huValidator;
            break;

        case 'id':
            countryFile = idValidator;
            break;

        case 'ie':
            countryFile = ieValidator;
            break;

        case 'il':
            countryFile = ilValidator;
            break;

        case 'in':
            countryFile = inValidator;
            break;

        case 'it':
            countryFile = itValidator;
            break;

        case 'jp':
            countryFile = jpValidator;
            break;

        case 'kr':
            countryFile = krValidator;
            break;

        case 'lt':
            countryFile = ltValidator;
            break;

        case 'lu':
            countryFile = luValidator;
            break;

        case 'mx':
            countryFile = mxValidator;
            break;

        case 'my':
            countryFile = myValidator;
            break;

        case 'nl':
            countryFile = nlValidator;
            break;

        case 'no':
            countryFile = noValidator;
            break;

        case 'nz':
            countryFile = nzValidator;
            break;

        case 'pe':
            countryFile = peValidator;
            break;

        case 'ph':
            countryFile = phValidator;
            break;

        case 'pl':
            countryFile = plValidator;
            break;

        case 'pt':
            countryFile = ptValidator;
            break;

        case 'ro':
            countryFile = roValidator;
            break;

        case 'se':
            countryFile = seValidator;
            break;

        case 'sg':
            countryFile = sgValidator;
            break;

        case 'sv':
            countryFile = svValidator;
            break;

        case 'th':
            countryFile = thValidator;
            break;

        case 'tr':
            countryFile = trValidator;
            break;

        case 'tw':
            countryFile = twValidator;
            break;

        case 'us':
            countryFile = usValidator;
            break;

        case 'vn':
            countryFile = vnValidator;
            break;

        case 'za':
            countryFile = zaValidator;
            break;
    }

    store.commit('form/setAttribute', { key: 'countryValidator', value: new countryFile() });
};

export const validate = (type, name, field = null) => {
    let value;
    let validator;

    if (type === 'quiz') {
        value = store.getters['quiz/getExtraData']('value', name)?.toString() || '';
        validator = store.getters['quiz/getExtraData']('validator', name);
    }

    if (type === 'form') {
        value = store.getters['form/getFieldData']('value', name)?.toString() || '';
        validator = store.getters['form/getFieldData']('validator', name);
    }

    return validateValue(value, validator, field);
};

export const validateValue = (value, validator, field = null) => {
    String.prototype.allReplace = function (obj) {
        let retStr = this;
        for (const x in obj) {
            retStr = retStr.replace(new RegExp(x, 'g'), obj[x]);
        }
        return retStr;
    };

    const countrySetting = store.state.form.attributes.countryValidator;
    const countryCode = store.state.page.countryCode;

    const countriesWithSpecialCharacters = ['cn', 'myzh', 'jp', 'gr', 'in', 'il'];
    const isCountryWithSpecialCharacters = countriesWithSpecialCharacters.includes(countryCode);

    value = value.allReplace({
        '０': '0',
        '１': '1',
        '２': '2',
        '３': '3',
        '４': '4',
        '５': '5',
        '６': '6',
        '７': '7',
        '８': '8',
        '９': '9',
        '。': '.',
        '｡': '.',
        '．': '.',
        '＠': '@',
    });

    const valueSpaceless = value.replace(/[^a-zA-Z0-9]/g, '');
    const valueTrimmed = value.trim();

    switch (validator) {
        case 'notRequired':
            return new notRequired().validate();

        case 'notEmpty':
            return new notEmpty().validate(field, value);

        case 'email':
            return new email().validate(valueTrimmed, countryCode, isCountryWithSpecialCharacters);

        case 'emailNotRequired':
            if (value) {
                return new email().validate(valueTrimmed, countryCode, isCountryWithSpecialCharacters);
            }

            return true;

        case 'number':
            return new number().validate(value);

        case 'numeric':
            return new numeric().validate(value, countrySetting.decimalSeparator);

        case 'alphabeticExt':
            return new alphabetic().validate(value, countryCode);

        case 'url':
            return new url().validate(value);

        case 'bankaccount':
        case 'iban':
            return new iban().validate(valueSpaceless);

        case 'date':
            return new date().validate(value, 0, countryCode);

        case 'birthdate':
            return new date().validate(value, 18, countryCode);

        case 'birthYear':
            return new birthYear().validate(value);

        case 'age':
            return new age().validate(field, value);

        case 'telephoneLibphonenumber':
            return new phone().validate(valueSpaceless, countryCode);

        case 'telephoneLibphonenumberWithoutTrailingZero':
            return new phone().validate('+' + phoneCode(countryCode) + valueSpaceless, countryCode);

        case 'telephoneNotRequired':
            if (value) {
                return new phone().validate(valueSpaceless, countryCode);
            }
            return true;

        case 'telephoneNotRequiredWithoutTrailingZero':
            if (value) {
                return new phone().validate('+' + phoneCode(countryCode) + valueSpaceless, countryCode);
            }
            return true;

        case 'mobileLibphonenumber':
            return new mobile().validate(valueSpaceless, countryCode);

        case 'mobileNotRequired':
            if (value) {
                return new mobile().validate(valueSpaceless, countryCode);
            }
            return true;

        case 'zipcode':
            return countrySetting.zipcode(value);

        case 'zipcodeNotRequired':
            if (value) {
                return countrySetting.zipcode(value);
            }
            return true;
    }
};
